import type { ReactElement } from "react";
import { UiIcon } from "./UiIcons";

interface SectionCtaProps { compact?: boolean; }

export const SectionCta = ({ compact = false }: SectionCtaProps): ReactElement => (
  <section className={`newborn-cta ${compact ? "newborn-cta--compact" : ""}`}>
    <div className="newborn-cta__icon"><UiIcon name="calendar" /></div>
    <div><h2>Ready to book your newborn session?</h2><p>Let&apos;s create beautiful memories together.</p></div>
    <a className="newborn-button newborn-button--coral" href="/contact/">Book your session <UiIcon name="arrow" /></a>
  </section>
);
